import { Badge } from "@/components/ui/badge";
import type { HandbookStatus } from "@/types/handbook";

const STATUS_CONFIG: Record<
  HandbookStatus,
  { label: string; className: string }
> = {
  draft: {
    label: "임시저장",
    className: "bg-gray-100 text-gray-700 border-gray-200",
  },
  published: {
    label: "발행됨",
    className: "bg-emerald-100 text-emerald-800 border-emerald-200",
  },
};

const FALLBACK = {
  label: "알 수 없음",
  className: "bg-gray-100 text-gray-500 border-gray-200",
};

export function HandbookStatusBadge({ status }: { status: string }) {
  const normalized = status.toLowerCase() as HandbookStatus;
  const config = STATUS_CONFIG[normalized] ?? FALLBACK;
  return (
    <Badge
      variant="outline"
      className={config.className}
      aria-label={`상태: ${config.label}`}
    >
      {config.label}
    </Badge>
  );
}
